<div class="alert alert-info" *ngIf="hints?.length > 0">
  <ng-template ngFor let-hint [ngForOf]="hints" let-i="index">
    <p class="font-size-17">{{hint}}</p>
    <hr *ngIf="hints.length !== (i + 1)" />
  </ng-template>
</div>